import React, { PureComponent } from 'react';
import query from '../../common/sparql/index';
import {
    SPARQL_ENDPOINT
} from '../../common/constants';
import { Dropdown, Grid } from 'semantic-ui-react';
import VegaChart from '../../common/vega/VegaChart';
import { beeswarmSpinOffs } from '../../common/vega/VegaSpecifications';
import * as _ from 'lodash';
import textures from 'textures';
import * as d3 from 'd3';
import Preloader from '../../components/Preloader';
import { queries } from '../../common/queries/index';
import { CSVLink } from "react-csv";
import {strings} from '../../common/translations'
import {LANG, LANG_SPECIFICS} from '../../common/constants'

let rtime;
var timeout = false;
const delta = 1000;

class DataVizSpinOffs extends PureComponent {
    

    constructor(props) {
        super(props);
        this.state = {
            atecoData: [],
            atecoSectors: [],
            atecoSectorsFilters: [],
            width: 0
        };


        this.handleAtecoSectorClick = this.handleAtecoSectorClick.bind(this);
    }



    resizeend = () => {
        if (new Date() - rtime < delta) {
            setTimeout(this.resizeend, delta);
        } else {
            timeout = false;
            this.setState({ width: window.innerWidth });
            // alert('Done resizing');
        }               
    }

    updateDimensions = () => {
        rtime = new Date();
        if (timeout === false) {
            timeout = true;
            setTimeout(this.resizeend, delta);
        } else {
            this.setState({ width: 0 });
        }
        // this.setState({ width: window.innerWidth });
    };


    async componentDidMount() {

        // Translate legends
        // COLOR
        // Title
        beeswarmSpinOffs["legends"][0]["title"] = strings.RICERCA_INNOVAZIONE.CHARTS.BEESWARM.LEGENDS.COLOR_TITLE;
        // Options
        beeswarmSpinOffs["legends"][0]["encode"]["labels"]["update"]["text"] = {"signal": "datum.value === 'si'? '" + strings.RICERCA_INNOVAZIONE.CHARTS.BEESWARM.LEGENDS.COLOR_VALUES.ACTIVE + "' : datum.value === 'no' ? '" + strings.RICERCA_INNOVAZIONE.CHARTS.BEESWARM.LEGENDS.COLOR_VALUES.INACTIVE + "' : datum.value == 'ignoto' ? '" + strings.RICERCA_INNOVAZIONE.CHARTS.BEESWARM.LEGENDS.COLOR_VALUES.NOT_KNOWN + "' : '" + strings.RICERCA_INNOVAZIONE.CHARTS.BEESWARM.LEGENDS.COLOR_VALUES.LIQUIDATION + "' "};
        // RADIUS
        // Title
        beeswarmSpinOffs["legends"][1]["title"] = strings.RICERCA_INNOVAZIONE.CHARTS.BEESWARM.LEGENDS.RADIO_TITLE;
        // Format options
        beeswarmSpinOffs["legends"][1]["encode"]["labels"]["update"]["text"]["signal"] = LANG_SPECIFICS[LANG].BEESWARM_LEGEND_FORMAT;

        // Translate mean text
        beeswarmSpinOffs["marks"][4]["encode"]["update"]["text"]["value"] = strings.RICERCA_INNOVAZIONE.CHARTS.BEESWARM.MEAN_LABEL;

        // Translate horizontal axis
        beeswarmSpinOffs["axes"][0]["encode"]["labels"]["update"]["text"]["signal"] = "datum.value == 0 ? '" + strings.RICERCA_INNOVAZIONE.CHARTS.BEESWARM.AXIS.START + "' : datum.value % 5 == 0 ? datum.value + ' " + strings.RICERCA_INNOVAZIONE.CHARTS.BEESWARM.AXIS.YEARS + "' : '' "

        // Tooltip
        beeswarmSpinOffs["marks"][0]["encode"]["hover"]["tooltip"]["signal"] = "{title : datum.name, '" + strings.RICERCA_INNOVAZIONE.CHARTS.BEESWARM.LEGENDS.RADIO_TITLE + "' : datum.founderCapital > 0 ? " + LANG_SPECIFICS[LANG].BEESWARM_TOOLTIP_FORMAT + " : '" + strings.RICERCA_INNOVAZIONE.CHARTS.BEESWARM.LEGENDS.COLOR_VALUES.NOT_KNOWN + "', '" + strings.RICERCA_INNOVAZIONE.CHARTS.BEESWARM.TOOLTIP.CREATION + "' : datum.lifetime + ' anni', '" + strings.RICERCA_INNOVAZIONE.CHARTS.BEESWARM.LEGENDS.COLOR_TITLE + "' : (datum.active === 'si' ? '" + strings.RICERCA_INNOVAZIONE.CHARTS.BEESWARM.LEGENDS.COLOR_VALUES.ACTIVE + "' : (datum.active === 'no' ? '" + strings.RICERCA_INNOVAZIONE.CHARTS.BEESWARM.LEGENDS.COLOR_VALUES.INACTIVE + "' : (datum.active === 'in liquidazione' ? '" + strings.RICERCA_INNOVAZIONE.CHARTS.BEESWARM.LEGENDS.COLOR_VALUES.LIQUIDATION + "' : '" + strings.RICERCA_INNOVAZIONE.CHARTS.BEESWARM.LEGENDS.COLOR_VALUES.NOT_KNOWN + "')))}"


        const atecoData = await query(SPARQL_ENDPOINT, queries.atecoData);
        const atecoSectors = await query(SPARQL_ENDPOINT, queries.atecoSectorsCount);
        
        this.setState({
            atecoData : atecoData,
            atecoSectors : atecoSectors,
            width: window.innerWidth
        });
        window.addEventListener('resize', this.updateDimensions);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions);
    }


    /**
     * Injects the selected values into a signal of the  vega specification
     * @param {SyntheticEvent} event 
     * @param {Object} data Array with the collection of selected values
     */
    handleAtecoSectorClick(event, data) {
        _.find(
            beeswarmSpinOffs.signals,
            s => s.name === 'atecoSectorsFilters'
        ).value = _.map(data.value, value => value);

        this.setState({
            atecoSectorsFilters: data.value
        });
    }



    render() {
        const { atecoData, atecoSectors, width } = this.state;
        
        const atecoSectorsOptions = _.map(
            atecoSectors,
            (atecoSector, index) => ({
                key: index,
                text: atecoSector.name + ' (' + atecoSector.count + ')',
                value: atecoSector.name
            })
        );

        const chartPadding = {"left": 5, "top": 5, "right": 80, "bottom": 5};

        if(atecoData.length > 0 && this.state.width !== 0)
            return (
                <Grid centered className='dataviz-spinoffs'>
                    <Grid.Row centered>
                        <Dropdown
                            placeholder={strings.RICERCA_INNOVAZIONE.CHARTS.BEESWARM.SELECTOR_PLACEHOLDER}
                            multiple
                            search                        
                            selection
                            options={atecoSectorsOptions}
                            onChange={this.handleAtecoSectorClick}
                        />
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column>
                            <VegaChart
                                id={"beeswarm-container"}
                                chartClass={'beeswarm'}
                                title={strings.RICERCA_INNOVAZIONE.CHARTS.BEESWARM.TITLE}
                                height={600}
                                width={width * 0.8}
                                padding={chartPadding}
                                data={atecoData}
                                spec={beeswarmSpinOffs}
                                runAfterCallback={ () => { 
                                    let texture = textures.lines().thicker();
                                    d3.select(".beeswarm svg").call(texture);
                                    d3.selectAll("g.nodes path[fill='white']").style('fill', texture.url());
                                }}
                            />
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row className="border-top">
                        <Grid.Column width={16} className="d-flex flex-wrap">
                            <CSVLink data={atecoData} 
                                     className="ui red circular icon button mx-auto"
                                     filename={"spinofCaratteristicheToscana.csv"}>
                                        <i aria-hidden="true" className="download icon"></i>
                            </CSVLink>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            );
        else
            return <Preloader message={strings.COMMON.LOADING_DATA} />
    }
}
export default DataVizSpinOffs;